  <div class="ama-ribbon__menu__explore">
    <!-- Mobile: accordion -->
    <p-accordion class="ama-ribbon__menu__explore__accordion">
      <p-accordion-panel value="explore">
        <p-accordion-header>Explore AMA Products</p-accordion-header>
        <p-accordion-content>
          <ul class="ama-ribbon__menu__explore__accordion__list">
            @for(item of amaExploreMenuItems; track $index){
              <li>
                <a href="{{ item.url }}"
                    (click)="navigateToExternalUrl('site menu', item.title, item.url, $event)"
                    title="{{ item.title }}"
                    target="_self"
                    class="ama-ribbon__menu__explore__accordion__link">
                  <span>{{ item.title }}</span>
                </a>
              </li>
            }
          </ul>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>

    <!-- Desktop: row of links -->
    <div class="ama-ribbon__menu__explore__desktop-container layout-container">
      @for(item of amaExploreMenuItems; track $index){
        <a href="{{ item.url }}"
            (click)="navigateToExternalUrl('site menu', item.title, item.url, $event)"
            title="{{ item.title }}"
            target="_self"
            class="ama-ribbon__menu__explore__desktop-link">
          <span>{{ item.title }}</span>
        </a>
      }
    </div>
</div>
  <div class="ama-ribbon">
  <nav class="ama-ribbon__content freida-v2  layout-container">
    <div class="ama-ribbon__menu-wrapper" (amaClickOutside)="closeMenu()">
      <app-burger-button
        [isOpen]="menuOpen"
        [color]="'#46166B'"
        (toggle)="menuOpen = $event"
        (click)="toggleMenu()"
        (keydown.enter)="toggleMenu()"
        (keydown)="onBackwardsKeyboardNav($event)"
      ></app-burger-button>

      <div class="ama-ribbon__menu ama-ribbon__menu--mobile" [ngClass]="{'open': isOpen}">
        <div>
        <ul class="ama-ribbon__menu ama-ribbon__menu--mobile__list">
          @if(currentUser().isMember) {
            <li class="ama-ribbon__menu ama-ribbon__menu--mobile__item dashboard">
              <app-button
                label="Dashboard"
                variant="primary"
                icon="bookmark-simple"
                (clicked)="goToDashboard(currentUser)"
              />
              </li>
          }

          @for(item of freidaNavigation?.[0]; track item.title){
          <li class="ama-ribbon__menu ama-ribbon__menu--mobile__item">
            @if (item.children?.length) {
              <p-accordion class="ama-ribbon__menu ama-ribbon__menu--mobile__accordion">
                <p-accordion-panel [value]="item.title">
                  <p-accordion-header>{{ item.title }}</p-accordion-header>
                  <p-accordion-content>
                    <ul class="ama-ribbon__menu ama-ribbon__menu--mobile__list">
                      @for(subItem of item.children; track $index){
                        <li class="ama-ribbon__menu ama-ribbon__menu--mobile__item">
                          <a href="{{ subItem.url }}"
                            (click)="closeMenu(); navigateTo('site menu', subItem.title, subItem.url, $event)"
                            title="{{ subItem.title }}"
                            target="_self"
                            [ngClass]="{'disabled': subItem.title === 'OBGYN ACI' && disableUpdates$()}"
                            class="ama-ribbon__menu ama-ribbon__menu--mobile__link">
                            <span>{{ subItem.title }}</span>
                          </a>
                        </li>
                      }
                    </ul>
                  </p-accordion-content>
                </p-accordion-panel>
              </p-accordion>
            } @else {
              <a href="{{ item.url }}"
                  (click)="navigateTo('site menu', item.title, item.url, $event)"
                  title="{{ item.title }}"
                  class="ama-ribbon__menu ama-ribbon__menu--mobile__link">
                <span>{{ item.title }}</span>
              </a>
            }
          </li>
        }
        </ul>
        </div>
      </div>
      <div class="ama-ribbon__menu ama-ribbon__menu--desktop" [ngClass]="{'open': isOpen}">
        <ul class="ama-ribbon__menu ama-ribbon__menu--desktop__list">
          @for(item of freidaNavigation?.[0]; track item.title){
            <li class="ama-ribbon__menu ama-ribbon__menu--desktop__item">
              @if (item.children?.length) {
                <p-accordion class="ama-ribbon__menu ama-ribbon__menu--desktop__accordion">
                  <p-accordion-panel [value]="item.title">
                    <p-accordion-header>{{ item.title }}</p-accordion-header>
                    <p-accordion-content>
                      <ul class="ama-ribbon__menu ama-ribbon__menu--desktop__submenu">
                        @for(subItem of item.children; track $index){
                          <li class="ama-ribbon__menu ama-ribbon__menu--desktop__item">
                            <a href="{{ subItem.url }}"
                              (click)="closeMenu(); navigateTo('site menu', subItem.title, subItem.url, $event)"
                              title="{{ subItem.title }}"
                              target="_self"
                              [ngClass]="{'disabled': subItem.title === 'OBGYN ACI' && disableUpdates$()}"
                              class="ama-ribbon__menu ama-ribbon__menu--desktop__link">
                              <span>{{ subItem.title }}</span>
                            </a>
                          </li>
                        }
                      </ul>
                    </p-accordion-content>
                  </p-accordion-panel>
                </p-accordion>
              } @else {
                <a #focusCheck (focus)="checkFocus()"
                  (click)="navigateTo('site menu', item.title, item.url, $event)"
                  href="{{ item.url }}" title="{{ item.title }}"
                  target="_self"
                  class="ama-ribbon__menu ama-ribbon__menu--desktop__link"
                >
                  <span>{{ item.title }}</span>
                </a>
              }
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="ama-ribbon__ama-logo__container">
      <a
        class="ama-ribbon__freida-logo"
        [attr.href]="logoUrl()"
        (click)="navigateTo('Logo', 'Freida logo', logoUrl(), $event)">
        <img src="assets/freida-logo.svg"
             alt="Freida"
             width="109"
             height="24"
             class="ama-ribbon__ama-logo--screen">
      </a>
      <a
        class="ama-ribbon__ama-logo"
        #focusEnd (focus)="checkFocus(true)"
        (click)="navigateToExternalUrl('Logo', 'AMA Logo', 'https://www.ama-assn.org/', $event)"
        title="AMA Logo"
        href="https://www.ama-assn.org/"
      >
        <img src="assets/ama-logo.svg"
            alt="American Medical Association"
            width="114"
            height="47"
            class="ama-ribbon__ama-logo--screen">
      </a>

      @if(!currentUser().isMember) {
        <div class="ama-ribbon__join ama-ribbon__join--desktop">
          <app-button (click)="navigateToExternalUrl('membership', 'Join', 'https://member.ama-assn.org/join-renew/member-search', $event)" variant="primary" label="Join" />
          <app-button  (click)="navigateToExternalUrl('membership', 'Renew', 'https://member.ama-assn.org/join-renew/member-search', $event)" variant="secondary" label="Renew" />
        </div>
      }
    </div>
    <div class="ama-ribbon__search__container">
      <div class="ama-ribbon__search--mobile">
          <div class="ama-ribbon__join ama-ribbon__join--mobile">
            @if(currentUser().isMember) {
              <div class="ama-ribbon__join ama-ribbon__join--mobile__dashboard">
                <div class="ama-ribbon__join ama-ribbon__join--mobile__dashboard-icon">
                  <app-button
                      label=""
                      variant="icon"
                      size="sm"
                      icon="bookmark-simple"
                      ariaLabel="Go to Dashboard"
                      (clicked)="goToDashboard(currentUser)"
                    />
                </div>
              </div>
            } @else {
              <a
              (click)="navigateToExternalUrl('join renew', 'Become a Member', 'https://member.ama-assn.org/join-renew/', $event)"
              href="https://member.ama-assn.org/join-renew/"
              class="ama-ribbon__join__button">
                Join or <br> Renew
              </a>
            }
          </div>

        <div class="ama-ribbon__search--mobile__search" (amaClickOutside)="searchOpen = false">
          <i class="search ph ph-magnifying-glass" role="button" tabindex="0" aria-label="Search" (click)="toggleSearchMenu()" (keydown.enter)="toggleSearchMenu()"></i>

          <div class="ama-ribbon__search--mobile__container" [ngClass]="{'open': searchOpen}">
              @if(searchOpen === true) {
                <ng-container *ngTemplateOutlet="searchTypeahead" />
              }
          </div>
        </div>



        <div class="ama-ribbon__search--mobile__user" role="button" tabindex="0" aria-label="User menu" (click)="toggleUserMenu(); $event.stopPropagation()" (keydown.enter)="toggleUserMenu(); $event.stopPropagation()">
          <i class="ama-ribbon__sign-in-dropdown__user ph ph-user-circle user" aria-hidden="true"></i>
        </div>
      </div>


      <div class="ama-ribbon__search--desktop">
        <ng-container *ngTemplateOutlet="searchTypeahead" />
      </div>
    </div>

    <a href="/memberbenefits" (click)="navigateTo('Membership', 'Member Benefits', '/memberbenefits', $event)" class="ama-ribbon__benefits">
      Member Benefits
    </a>

    <div class="ama-ribbon__sign-in-dropdown"
      (click)="toggleUserMenu(); $event.stopPropagation()">
      <i class="ama-ribbon__sign-in-dropdown__user ph ph-user-circle user"></i>
      <span class="ama-ribbon__sign-in-dropdown__text" tabindex="0" (keydown)="onBackwardsKeyboardNav($event)" [attr.aria-label]="isUserOpen ? 'Sign in dropdown menu open press enter to close' : 'Sign in dropdown menu closed press enter to open'" (keydown.enter)="toggleUserMenu()">{{ currentUser().name }}</span>
      <i class="ama-ribbon__sign-in-dropdown__caret ph" [ngClass]="isUserOpen ? 'ph-caret-up' : 'ph-caret-down'"></i>
    </div>

    <div class="ama-ribbon__sign-in-dropdown__menu" [ngClass]="{'open': isUserOpen}" (amaClickOutside)="closeUserMenu()">
      <ul role="presentation" class="ama-ribbon__sign-in-dropdown__menu__group">
        @if (currentUser().name.trim() === 'Sign In') {
          <li>
            <p class="ama-ribbon__sign-in-dropdown__menu__title">
              Sign In To Enjoy Your AMA Benefits
            </p>
          </li>
          <li class="ama-ribbon__sign-in-dropdown__menu__item">
            <app-button
              label="Sign In"
              variant="primary"
              [fullWidth]="true"
              [disabled]="disableUpdates$()"
              (clicked)="checkForLogout('Sign In')"
              class="ama-ribbon__sign-in-dropdown__menu__link--first">
            </app-button>
          </li>
        } @else {
          <li class="ama-ribbon__sign-in-dropdown__menu__item">
            <app-button
              label="Sign Out"
              variant="primary"
              [fullWidth]="true"
              (clicked)="checkForLogout(currentUser().name.trim())"
              class="ama-ribbon__sign-in-dropdown__menu__link--first">
            </app-button>
          </li>
        }
        @if(currentUser().isMember) {
          <li class="ama-ribbon__sign-in-dropdown__menu__item">
            <a role="link"
              (focus)="isUserMenuFocused = true; isUserOpen = true"
              (click)="goToDashboard()"
              class="ama-ribbon__sign-in-dropdown__menu__link"
              [tabindex]="isUserOpen ? 0 : -1"
              [ngClass]="{'disabled': disableUpdates$()}">
              <span>Member Dashboard</span>
            </a>
          </li>
        } @else {
          <li class="ama-ribbon__sign-in-dropdown__menu__item">
            <a target="_self"
              [tabindex]="isUserOpen ? 0 : -1"
              (click)="navigateToExternalUrl('join renew', 'Become a Member', 'https://member.ama-assn.org/join-renew/', $event)"
              href="https://member.ama-assn.org/join-renew/"
              class="ama-ribbon__sign-in-dropdown__menu__link">
              <span>Become a Member</span>
            </a>
          </li>
          <li class="ama-ribbon__sign-in-dropdown__menu__item">
            <a target="_self"
              (focus)="isUserMenuFocused = true; isUserOpen = true"
              [tabindex]="isUserOpen ? 0 : -1"
              (click)="navigateToExternalUrl('sign in dropdown', 'Create Free Account', 'https://fsso.ama-assn.org/sign-up', $event)"
              href="https://fsso.ama-assn.org/sign-up"
              class="ama-ribbon__sign-in-dropdown__menu__link">
              <span>Create Free Account</span>
            </a>
          </li>
        }
      </ul>
    </div>
  </nav>
</div>

@defer (on idle) {
  <app-browse-specialties
    [isModalOpen]="isModalOpen"
    [width]="'800px'"
    (searchClicked)="searchSpecialty($event)"
    (closeModal)="isModalOpen = false"
  />
}

<ng-template #searchTypeahead>
  <app-autocomplete-search
    class="ama-ribbon__search-typeahead"
    [disableFirstOptionOnSubmit]="true"
    [resetToken]="resetTypeaheadToken()"
    [hintTemplate]="hintTemplate"
    [placeholder]="'Search programs or specialties'"
    [minChars]="3"
    [apiMode]="true"
    [options]="options()"
    [suggestions]="suggestions()"
    suggestionLabel="PROGRAMS"
    hintMessage="Search requires a minimum of 3 characters"
    [searchButton]="searchButton"
    [panelClass]="panelClass"
    [searchType]="'specialty'"
    (typeahead)="onTypeahead($event)"
    (cleared)="onCleared()"
    (search)="onSearch($event)"
    (selectedValue)="onSelectedValue($event)"
    data-test="typeahead"
  />
</ng-template>

<ng-template #hintTemplate>
  <span>
    <span>Search requires a minimum of 3 characters</span>
    <app-button variant="link" label="View All Specialties" (clicked)="openSpecialtiesModal()" />
  </span>
</ng-template>
